
<template>
  <v-layout row wrap class="global--background" v-bind:class="{ 'global--background-shrink': shrink }">

    <v-flex xs12 sm4>
      <v-card class="mycard" to="ctdit-news">
        <v-img src="/static/img/ctdit/logo_ctdit2.png" height="200px"></v-img>
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">CTDIT</h3>
            <div>
               Le CTDIT, unité du Service de Diabétologie - Maladies Métaboliques- Nutrition du CHU de Toulouse, a pour missions,
               la conception, le développement et l’expérimentation
               d’outils de télé-éducation et de télésurveillance dans le domaine de la diabétologie, nutrition et activité physique
            </div>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-btn tttto="ctdit-news" flat color="orange">En savoir plus...</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-flex xs12 sm4>
      <v-card class="mycard">
        <v-img src="/static/img/chu/logo_lyon3.png" height="240px"></v-img>
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">Protocole Diamond-GLP1</h3>
            <div>Diamond-GLP1 est un protocole visant à évaluer un nouveau traitement stimulant la sécrétion d’insuline
              résiduelle de certains diabétiques de type 1.
            </div>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-btn to="diamond-news" flat color="orange">En savoir plus...</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-flex xs12 sm4>
      <v-card class="mycard">
        <v-img src="/static/img/news/LOGO_salutance50-2.png" height="150px"></v-img>
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">Salutance 5.0</h3>
            <div>Le programme SALUTANCE 5.0 a pour objectif d’aider les personnes de 45 à 55 ans en surpoids ou obèses,
              à modifier leurs habitudes de vie et à perdre du poids
            </div>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-btn href="https://www.salutance.fr" target="_blank" flat color="orange">En savoir plus...</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-flex xs12 sm4>
      <v-card class="mycard" to="/tools">
        <v-img src="/static/img/ctdit/calculator.jpg" height="150px"></v-img>
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">Outils divers</h3>
            <div>
              Vous trouverez ici différents outils permettant de <a href="#/imc">calculer votre IMC</a>,
              d'évaluer votre activité physique, et bien d'autres
            </div>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-btn to="/tools" flat color="orange">En savoir plus...</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-flex xs12 sm4>
      <v-card class="mycard" to="/nutrikiosk">
        <v-img src="/static/img/malnutrition/malnutrition.jpg" height="200px"></v-img>
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">NutriKiosk : pour comprendre la nutrition en s'amusant</h3>
            <div>
               Cette application développée par le CTDIT permet d'enrichir ses connaissances
               en nutrition de façon ludique
            </div>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-btn to="/nutrikiosk" flat color="orange">En savoir plus...</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-flex xs12 sm4>
      <v-card class="mycard">
        <v-img src="/static/img/news/Icon1024x1024.png" height="200px"></v-img>
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">Educ@dom</h3>
            <div>Le dispositif de télésurveillance proposé à des patients diabétiques de type 2 à leur domicile associe trois logiciels
              d’éducation et des capteurs de données biomédicales 
            </div>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-btn to="news-educadom" flat color="orange">En savoir plus...</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

  </v-layout>

</template>



<script>

   export default {
      data () {
         return {
            title: 'Diabétologie, Nutrition et Hygiène de vie',
            shrink: false,
            interval: null,
         }
      },
      mounted () {
         // start shrinking background image
         this.shrink = true
      },
      methods: {
        salutanceInfo: function() {
          console.log('ee')
        }
      }
   }

</script>


<style scoped>


   /* appearing / disappearing views */
   .global--appearing {
      animation-name: global--appearing;
      animation-duration: 0.5;
      animation-fill-mode: forwards;
      animation-iteration-count: 1;
   }
   @keyframes global--appearing {
      from { opacity: 0; }
      to { opacity: 1.0; }
   }
   
   .global--disappearing {
      animation-name: global--disappearing;
      animation-duration: 0.5;
      animation-fill-mode: forwards;
      animation-iteration-count: 1;
   }
   @keyframes global--disappearing {
      from { opacity: 1.0; }
      to { opacity: 0; }
   }


   .global--background {
      background-image: url("/static/img/common/bg_login@3x.jpg");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
   }
   @keyframes global--background-shrink {
      0% { background-size: 120% auto; }
      100% { background-size: 100% auto; }
   }
   .global--background-shrink {
      animation-name: global--background-shrink;
      animation-duration: 20s;
      animation-fill-mode: forwards;
      animation-iteration-count: 1;
      animation-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
   }


.mycard {
  margin: 20px;
}

</style>



// WEBPACK FOOTER //
// NutrieducNews.vue?633613da